import { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import { selectAtom } from 'jotai/utils'

import { authProfileAtom } from '../atoms/auth-profile.atom'

export const useAuthProfileValue = () => {
    const profile = useAtomValue(
        useMemo(() => selectAtom(authProfileAtom, (profile) => profile), [])
    )

    return {
        profile,
    }
}
